globalThis.Module = {
  onRuntimeInitialized: function () {
    onWasmLoaded();
  },
};

import { initWasm } from "./mn-media.js";
import * as Common from "./mn-common.js";
initWasm(Module);
// import wasmUrl from './mn-media.wasm?url'
// const res = fetch(wasmUrl)
/**
 * @description: web worker用于流媒体获取（websocket）及编（音频）、解码（音视频）、对讲
 * @author: lantf
 * @date: 2020/10/18 15:28
 */

// self.importScripts("mn-common.js");
// self.importScripts("mn-media.js"); // 加载wasm视频解码器 直接作为JS运行

class MnWorker {
  constructor() {
    this.ws = "ws";
    this.host = "";
    this.port = 0;
    this.deviceType = "";
    this.phone = "";
    this.channel = 0;
    this.messageId = 0;
    this.mediaType = 0;
    this.streamType = 0;
    this.beginTime = "";
    this.playbackMode = 0;
    this.ctrlSendTime0 = 0;
    this.ctrlSendTime1 = 0;
    this.netSpeedTimer = null;
    this.realPlayTimer = null;
    this.playBackTimer = null;
    this.lang = null;
    this.playAudio = false;
    this.coreLogLevel = 0;
    this.cacheReqQue = [];
    this.cacheDataQue = [];
    this.recorderLen = 0;
    this.decoding = true;
    this.wasmLoaded = false;
    this.hasConnected = false;
    this.hasInited = false;
    this.hasCached = false;
    this.decoderInited = false;
    this.chunkSize = 1024 * 1024;
    this.websocket = null;
    this.cacheBuffer = null;
    this.speakBuffer = null;
    this.readyCallback = null;
    this.videoCallback = null;
    this.audioCallback = null;
    this.preTimeStamp = 0;
    this.shouldPlayNextTime = 0;
    this.pauseTime = 0;
    this.resumeTime = 0;
    this.delayTime = 1000;
    this.keyFrame = null;
    this.netSpeedTime = 1;
    this.netSpeedSize = 0;
    this.heartBeatTime = 0;
    this.fastForward = false;
    this.voiceScheduling = false; // 语音调度
    this.prefix = "/mndp/stream";
    this.logger = new Common.Logger("MnWorker");
    this.userId = null;
    this.tenantId = null;
    this.token = null;
    //  * 倍速 (0-无效，1-1倍，2-2倍，3-4倍，4-8倍，5-16倍)
    this.speed = 0;
    this.isPause = false;
    this.speedValue = 1;
    this.isStreamPause = false;
    this.streamPauseTime = 0;
    this.playMode = 0; // 0-实时 1-回放
    this.voiceTimeStamp = 0;
    this.offsetTime = 0;
    this.offsetDelay = 0;
    this.isCacheLow = false;
    this.isFirstLoaded = false;
    this.checkCacheTimer = null;
  }

  /* 偏移 */
  offset(time) {
    /* 如果是倍速则不比较 */
    if (this.speed > 2) {
      return;
    }
    this.offsetDelay = 0;
    if (!time) return;
    this.offsetTime = parseInt(time);
    let isVideoFast = false;
    if (this.offsetTime > 0) {
      /* 视频慢了减少等待时间 */
      isVideoFast = false;
    } else {
      /* 视频快了增加等待时间 */
      isVideoFast = true;
    }

    if (Math.abs(this.offsetTime) > 2000) {
      /* 超过2s需要处理 */
      /* 严重不同步 */
      // console.log("严重不同步！", this.offsetTime);
      this.offsetDelay = isVideoFast ? +200 : -200;
      return;
    }
    if (Math.abs(this.offsetTime) > 1000) {
      /* 超过1s需要处理 */
      /* 稍微不同步 */
      // console.log("延迟", this.offsetTime);
      this.offsetDelay = isVideoFast ? +100 : -100;
      return;
    }
    if (Math.abs(this.offsetTime) > 200) {
      /* 超过200ms需要处理 */
      /* 稍微不同步 */
      // console.log("延迟", this.offsetTime);
      this.offsetDelay = isVideoFast ? +10 : -10;
      return;
    }
  }

  /**
   * 打开解码器
   **/
  baseInit() {
    this.cacheBuffer = Module._malloc(this.chunkSize);
    this.speakBuffer = Module._malloc(1024);
    let phoneBuffer = Module._malloc(16);
    Module.HEAPU8.set(this.toInt8Array(this.phone), phoneBuffer);
    let ret = Module._baseInit(
      phoneBuffer,
      this.channel,
      this.readyCallback,
      this.videoCallback,
      this.audioCallback,
      this.speakCallback,
      this.coreLogLevel,
    );
    if (phoneBuffer) {
      Module._free(phoneBuffer);
    }

    let objData = {
      t: Common.kOpenDecoderRsp,
      e: ret,
    };
    self.postMessage(objData);
  }

  /**
   * 关闭解码器
   **/
  baseUnInit() {
    let ret = 0;
    Module._videoUnInit();
    Module._baseUnInit();

    if (this.cacheBuffer != null) {
      Module._free(this.cacheBuffer);
      this.cacheBuffer = null;
    }
    if (this.speakBuffer != null) {
      Module._free(this.speakBuffer);
      this.speakBuffer = null;
    }

    this.decoderInited = false;

    let objData = {
      t: Common.kCloseDecoderRsp,
      e: ret,
    };
    self.postMessage(objData);
  }

  /**
   * 统计流量
   **/
  calNetSpeed() {
    const speed = this.netSpeedSize / this.netSpeedTime;
    const len = this.cacheDataQue.length;
    this.netSpeedSize = 0;
    let objData = {
      t: Common.kNetSpeedFrame,
      d: speed,
      len,
    };
    self.postMessage(objData);

    // 心跳（this.netSpeedTime的10倍秒数）
    this.heartBeatTime += this.netSpeedTime;
    if (this.websocket != null && this.hasConnected) {
      if (this.heartBeatTime % (this.netSpeedTime * 10) == 0) {
        let req = {};
        req.phone = this.phone;
        req.channel = this.channel;
        req.messageId = 0x0000;
        let json = JSON.stringify(req);
        this.websocket.send(json);
      }
    }
  }
  uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  }
  /**
   * 打开websocket码流链路
   **/
  openStream() {
    const uid = this.uuid();
    let url =
      this.ws +
      "://" +
      this.host +
      ":" +
      this.port +
      this.prefix +
      "/" +
      this.phone +
      "-" +
      this.channel +
      `?user_id=${this.userId}&tenant_id=${this.tenantId}&access_token=${this.token}&host_uuid=${uid}`;
    this.websocket = new WebSocket(url);
    this.websocket.binaryType = "arraybuffer";

    this.websocket.onopen = function () {
      self.decoder.onOpen();
    };

    this.websocket.onmessage = function (ev) {
      if (typeof ev.data === "string") {
        let objData = {
          t: Common.kStringFrame,
          d: ev.data,
        };
        self.postMessage(objData);
      } else {
        self.decoder.sendData(ev.data);
      }
    };

    this.websocket.onerror = function () {
      let message = "1连接视频服务器失败";
      switch (self.decoder.lang) {
        case "zh-CN,zh;":
          message = "1连接视频服务器失败";
          break;
        case "zh-TW,zh;":
          message = "1連接視訊伺服器失敗";
          break;
        case "en-US,en;":
          message = "1Failed to connect to video server";
          break;
        case "ru-RU,ru;":
          message = "1Ошибка подключения к видео серверу";
          break;
        case "kk-KZ,kk;":
          message = "1Видео серверіне қосылу жаңылысы";
          break;
      }
      let objData = {
        t: Common.kSocketErrorRsp,
        d: message,
      };
      self.postMessage(objData);
      this.websocket.close();
      this.websocket = null;
    };

    this.websocket.onclose = function () {
      self.decoder.stopCheckCache();
      let message = "1网络连接断开，请稍候再试";

      switch (self.decoder.lang) {
        case "zh-CN,zh;":
          message = "1网络连接断开，请稍候再试";
          break;
        case "zh-TW,zh;":
          message = "1網絡連接斷開，請稍候再試";
          break;
        case "en-US,en;":
          message = "1Disconnected, please try again later";
          break;
        case "ru-RU,ru;":
          message = "1Соединение прервано, повторите попытку позже.";
          break;
        case "kk-KZ,kk;":
          message = "1Байланыс ажыратылды, әрекетті кейінірек қайталаңыз.";
          break;
        case "th-TH,th;":
          message = "การเชื่อมต่อถูกตัดการเชื่อมต่อ โปรดลองอีกครั้งในภายหลัง";
          break;
      }
      let objData = {
        t: Common.kSocketCloseRsp,
        d: message,
      };
      if (self.decoder.serverError != "") {
        // 用后端返回的提示（若有）
        objData.d = self.decoder.serverError;
      }
      self.decoder.websocket = null;
      self.decoder.hasConnected = false;
      self.decoder.mnWorker = null;
      self.postMessage(objData);
      this.websocket = null;
    };
  }

  /**
   * 切换码流
   **/
  switchStream(mediaType, streamType) {
    if (this.websocket != null && this.hasConnected) {
      let req = {};
      req.phone = this.phone;
      req.channel = this.channel;
      req.messageId = 0x9102;
      req.command = 1;
      req.closeType = 0;

      if (mediaType != null) {
        req.mediaType = mediaType;
        this.mediaType = mediaType;
      }

      if (streamType != null) {
        req.streamType = streamType;
        this.streamType = streamType;
      }

      let json = JSON.stringify(req);
      this.websocket.send(json);
    } else {
      this.logger.logInfo("Web socket is null or not connected.");
    }
  }

  /**
   * 发送制命令
   **/
  play() {
    if (this.websocket == null) {
      this.logger.logInfo("Web socket is null");
      return;
    }
    let req = {};
    req.phone = this.phone;
    req.channel = this.channel;
    req.messageId = this.messageId;
    req.mediaType = this.mediaType;
    req.streamType = this.streamType;
    req.beginTime = this.beginTime;
    this.playMode = this.beginTime ? 1 : 0;
    req.acceptLanguage = this.lang;
    req.ws = this.ws;
    req.host = this.host;
    req.port = this.port;
    req.deviceType = this.deviceType;
    let json = JSON.stringify(req);
    this.websocket.send(json);
  }

  /**
   * ws建立后初始化
   **/
  onOpen() {
    this.baseInit();
    this.resume();
    this.startCheckCache();
    this.play();
    this.hasConnected = true;
    if (this.mediaType !== Common.kMediaSpeak) {
      this.netSpeedTimer = setInterval(
        this.calNetSpeed.bind(this),
        this.netSpeedTime * 1000,
      );
    }
  }

  /**
   * 恢复解码
   **/
  resume() {
    // console.log('resume解码')
    this.isPause = false;
    if (this.mediaType !== Common.kMediaSpeak) {
      if (this.beginTime) {
        this.resumeTime = new Date().getTime();
        let pauseDuration = this.resumeTime - this.pauseTime;
        this.shouldPlayNextTime += pauseDuration;
        this.playBack();
      } else {
      }
    }
    this.decoding = true;
  }

  /**
   * 暂停解码
   **/
  pause() {
    this.isPause = true;
    if (!this.beginTime) {
      this.decoding = false;
      clearTimeout(this.realPlayTimer);
      this.realPlayTimer = null;
      this.cacheReqQue.length = 0;
      this.hasInited = false;
      this.hasCached = false;
    } else {
      this.pauseTime = new Date().getTime();
      // console.log("暂停");
      // this.decoding = false;
      clearTimeout(this.playBackTimer);
    }
  }

  realPlay(u8a, frameType, ptRaw) {
    if (this.hasInited == false) {
      // 获取编码类型，初始化视频解码器
      if (this.renderMode == 1) {
        if (u8a) {
          const ti = this.timeStamp(u8a);
          // console.log("收到帧时间", ti);
          let dataString = "";
          let dataLen = u8a.length - 16;
          for (let i = 0; i < 16; i++) {
            dataString += String.fromCharCode(u8a[dataLen + i]);
          }
          let frameType = Number(dataString.substr(13, 1));
          let isKey = false;
          if (frameType == 0) {
            isKey = true;
          }
          self.postMessage({
            t: Common.kVideoFrameOriginRsp,
            ti: ti,
            isKey: isKey,
            d: u8a,
          });
        }
      } else {
        if (!this.decoderInited) {
          let decoderType = Common.kDecoderH264;
          if (ptRaw == 99) {
            decoderType = Common.kDecoderH265;
          }
          Module._videoInit(decoderType);
          this.decoderInited = true;
        }
        // 获取帧类型，必须先出个I帧，否则丢弃
        if (frameType == 0) {
          this.hasInited = true;
        }
      }
    }

    if (this.decoding && this.hasInited) {
      Module.HEAPU8.set(u8a, this.cacheBuffer);
      Module._decodeVideo(this.cacheBuffer, u8a.length - 16);
      this.preTimeStamp = this.timeStamp(u8a);
    }
  }
  /* 检测缓存 */
  startCheckCache() {
    setInterval(() => {
      clearInterval(this.checkCacheTimer);
      this.checkCacheAndCtrl();
      this.ctrlSendTime0 = 0;
      this.ctrlSendTime1 = 0;
    }, 3000);
  }
  stopCheckCache() {
    clearInterval(this.checkCacheTimer);
  }
  /**
   * 回放视频解码
   **/
  async playBack() {
    try {
      clearTimeout(this.playBackTimer);
      if (this.isPause) return;

      do {
        let shouldDecode = true;
        this.checkCacheAndCtrl();
        let queLen = this.cacheDataQue.length;
        if (queLen == 0) {
          break;
        }
        // 首先渲染出I帧
        if (this.hasInited === false && this.renderMode == 0) {
          let u8a = this.cacheDataQue.shift();

          // 取出帧尾16个字符
          let dataString = "";
          let dataLen = u8a.length - 16;
          for (let i = 0; i < 16; i++) {
            dataString += String.fromCharCode(u8a[dataLen + i]);
          }

          // 获取时间戳
          this.preTimeStamp = Number(dataString.substr(0, 13));
          // 获取编码类型，初始化视频解码器
          if (!this.decoderInited) {
            let decoderType = Common.kDecoderH264;
            if (dataString.substr(14) == 99) {
              decoderType = Common.kDecoderH265;
            }
            Module._videoInit(decoderType);
            this.decoderInited = true;
          }

          // 获取帧类型，若是I帧，则立即渲染
          let frameType = Number(dataString.substr(13, 1));
          if (this.decoding && frameType == 0) {
            Module.HEAPU8.set(u8a, this.cacheBuffer);
            Module._decodeVideo(this.cacheBuffer, dataLen);
            this.hasInited = true;
            this.shouldPlayNextTime = new Date().getTime();
          }
          break;
        }

        let u8aHead = this.cacheDataQue.shift();
        let headTimeStamp = this.timeStamp(u8aHead);
        /* 本帧和上一帧的延迟 */
        let delay = headTimeStamp - this.preTimeStamp;
        delay = Math.max(-10, delay);
        // console.log('delay',delay)
        if (this.speed) {
          delay = delay / this.speed;
        }
        /* 同步音频需要追或慢 */
        if (this.offsetDelay) {
          // console.log('this.offsetDelay',this.offsetDelay)
          delay = delay + this.offsetDelay;
        }
        // console.log('this.offsetDelay',this.offsetDelay)
        /* 该帧应播时间 */
        this.shouldPlayNextTime = this.shouldPlayNextTime + delay;
        let now = new Date().getTime();
        let d = this.shouldPlayNextTime - now - 10;
        if (this.renderMode == 1) {
          d = 30 / this.speed;
          if (this.speed == 0) {
            d = 30;
          }
        }
        // console.log('d',d)
        if (now >= this.shouldPlayNextTime) {
          if (d < -2000) {
            if (this.renderMode == 0) {
              // console.log("播放太慢了 跳帧", d, delay);

              while (true) {
                if (this.cacheDataQue.length > 0) {
                  /* 寻找时间最接近的I帧 */
                  let dataString = "";
                  let dataLen = u8aHead.length - 16;
                  for (let i = 0; i < 16; i++) {
                    dataString += String.fromCharCode(u8aHead[dataLen + i]);
                  }
                  let frameType = Number(dataString.substr(13, 1));
                  if (frameType == 0) {
                    /* 是I帧 */
                    /* 帧时间 */
                    let headTimeStamp = this.timeStamp(u8aHead);
                    /* 当前帧与之前帧的时间差 */
                    let delay = headTimeStamp - this.preTimeStamp;
                    if (this.speed) {
                      delay = delay / this.speed;
                    }
                    this.shouldPlayNextTime = this.shouldPlayNextTime + delay;
                    break;
                  } else {
                    // console.log('寻找下一帧');
                    if (this.cacheDataQue.length > 0) {
                      u8aHead = this.cacheDataQue.shift();
                    } else {
                      // console.log("没有帧了等待");
                      this.hasInited = false;
                      shouldDecode = false;
                      this.shouldPlayNextTime = new Date().getTime();
                      break;
                    }
                  }
                } else {
                  this.hasInited = false;
                  shouldDecode = false;
                  this.shouldPlayNextTime = new Date().getTime();
                  break;
                }
              }
            }
          }
        } else {
          if (d > 10000) {
            // 跨段等待1秒
            // console.log("跨段");
            d = 500;
            this.shouldPlayNextTime = new Date().getTime() + d;
          }
          await this.sleep(d);
        }
        if (this.renderMode == 1) {
          let u8a = u8aHead;
          let dataString = "";
          let dataLen = u8a.length - 16;
          for (let i = 0; i < 16; i++) {
            dataString += String.fromCharCode(u8a[dataLen + i]);
          }
          let frameType = Number(dataString.substr(13, 1));
          let isKey = false;
          if (frameType == 0) {
            isKey = true;
            // console.log("this.timeStamp(u8a)", this.timeStamp(u8a));
          }
          self.postMessage({
            t: Common.kVideoFrameOriginRsp,
            ti: this.timeStamp(u8a),
            isKey: isKey,
            d: u8a,
          });
        } else if (shouldDecode) {
          if (this.decoding) {
            Module.HEAPU8.set(u8aHead, this.cacheBuffer);
            Module._decodeVideo(this.cacheBuffer, u8aHead.length - 16);
          }
        }
        this.preTimeStamp = headTimeStamp;
      } while (false);
      this.playBackTimer = setTimeout(this.playBack.bind(this), 4);
    } catch (e) {
      this.playBackTimer = setTimeout(this.playBack.bind(this), 4);
    }
  }

  dateFormat(fmt, date) {
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(), // 年
      "m+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "H+": date.getHours().toString(), // 时
      "M+": date.getMinutes().toString(), // 分
      "S+": date.getSeconds().toString(), // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(
          ret[1],
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"),
        );
      }
    }
    return fmt;
  }

  /**
   * 历史回放控制
   **/
  playBackCtrl(pause) {
    // 兜底添加一个节流
    if (new Date().getTime() - this.streamPauseTime < 1000) {
      return;
    }
    // console.log("下发回放控制命令", pause, this.cacheDataQue.length);
    this.streamPauseTime = new Date().getTime();
    if (pause) {
      this.isStreamPause = true;
      if (this.playbackMode == 1) {
        this.ctrlSendTime1++;
        /* 已经发送过了 正常不再发送防止消息丢失 重发机制 */
        if(this.ctrlSendTime1 > 2){
          return
        }
      }
      this.ctrlSendTime0 = 0;
      this.playbackMode = 1;
    } else {
      this.isStreamPause = false;
      if (this.playbackMode == 0) {
        this.ctrlSendTime0++;
        if(this.ctrlSendTime0 > 2){
          return
        }
      }
      this.ctrlSendTime1 = 0;
      this.playbackMode = 0;
    }

    let req = {};
    req.phone = this.phone;
    req.channel = this.channel;
    req.messageId = 0x9202;
    req.mediaType = this.mediaType;
    req.streamType = this.streamType;
    req.beginTime = this.beginTime;
    req.acceptLanguage = this.lang;
    req.playbackMode = this.playbackMode;
    let json = JSON.stringify(req);

    if (this.websocket != null) {
      if (this.websocket.readyState === this.websocket.OPEN) {
        this.websocket.send(json);
      } else {
        this.websocket = null;
      }
    }
  }

  /**
   * 获取时间戳
   **/
  timeStamp(u8a) {
    let dataString = "";
    let dataLen = u8a.length - 16;

    for (let i = 0; i < 16; i++) {
      dataString += String.fromCharCode(u8a[dataLen + i]);
    }

    return Number(dataString.substr(0, 13));
  }

  /**
   * 获取数组中最后一个I帧的索引
   **/
  frameIndex() {
    let index = -1;
    for (let i = 0; i < this.cacheDataQue.length; i++) {
      let u8a = this.cacheDataQue[i];
      let dataLen = u8a.length - 16;
      if (u8a[dataLen + 13] == 48) {
        // 48 <=> '0'
        index = i;
      }
    }
    return index;
  }

  /**
   * 延时
   **/
  sleep(ms) {
    if (ms > 0) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    return Promise.resolve();
  }

  /**
   * 往码流链路发音频控制命令
   **/
  enableAudio(d) {
    this.playAudio = d;
    /*    if (this.websocket != null) {
        let req = {};
        req.phone = this.phone;
        req.channel = this.channel;
        if (d) {
            req.messageId = 0x9601;
        } else {
            req.messageId = 0x9600;
        }
        let json = JSON.stringify(req);
        this.websocket.send(json);
    } else {
        this.logger.logInfo("Web socket is null");
    }*/
  }

  /**
   * 关闭websocket码流链路
   **/
  closeStream() {
    this.pause();

    if (this.websocket != null) {
      this.websocket.onmessage = null;
      this.websocket.onerror = null;
      this.websocket.onopen = null;
      this.websocket.close();
      this.websocket = null;
    }

    if (this.netSpeedTimer != null) {
      clearInterval(this.netSpeedTimer);
      this.netSpeedTimer = null;
    }

    this.baseUnInit();
  }

  /**
   * 码流信息解码
   **/
  sendData(data) {
    if (!this.decoding) {
      return;
    }
    let u8a = new Uint8Array(data);
    this.netSpeedSize += u8a.length;
    //u8a = u8a.subarray(26, 114); // 去掉rtp头，可用于对讲测试
    let dataString = "";
    let dataLen = u8a.length - 16;
    for (let i = 0; i < 16; i++) {
      dataString += String.fromCharCode(u8a[dataLen + i]);
    }

    let frameType = Number(dataString.substr(13, 1));
    let ptRaw = dataString.substr(14);
    if (
      u8a[0] == 0 &&
      u8a[1] == 0 &&
      u8a[2] == 0 &&
      u8a[3] == 1 &&
      (ptRaw == 98 || ptRaw == 99)
    ) {
      if (this.beginTime) {
        // 回放，走流控
        this.cacheDataQue.push(u8a);
        this.checkCacheAndCtrl();
      } else {
        this.realPlay(u8a, frameType, ptRaw); // 实时，直接解码
      }
    } else {
      // if (this.mediaType !== Common.kMediaSpeak && !this.playAudio) {
      //   // 监听时，按声音开关控制播放音频
      //   return;
      // }
      if (!this.voiceScheduling) {
        // 语音调度不播放上行音频
        // 最后一字节为音频编码类型
        if (dataString.indexOf("306") > 0) {
          u8a = u8a.slice(0, -15);
          u8a[u8a.length - 1] = 6;
          const nowAudioTime = dataString.slice(0, 13);
          if (
            this.voiceTimeStamp !== 0 &&
            Math.abs(nowAudioTime - this.voiceTimeStamp) > 1000
          ) {
            /* 如果音频跨段主动flush一次 */
            let objData = {
              t: Common.kFlushAudio,
              d: this.voiceTimeStamp,
            };
            self.postMessage(objData);
          }
          this.voiceTimeStamp = nowAudioTime;
        }
        // console.log('dataString',dataString)
        Module.HEAPU8.set(u8a, this.cacheBuffer);
        Module._decodeAudio(
          this.cacheBuffer,
          u8a.length - 1,
          u8a[u8a.length - 1],
        );
      }
    }
  }

  checkCacheAndCtrl() {
    if (this.playMode == 0) {
      return;
    }
    let min = 10;
    let max = 30;
    if (this.playbackMode == 6) {
      // 帧播放
      min = 1;
      max = 5;
    }
    let queLen = this.cacheDataQue.length;
    if (queLen == 0 && !this.isFirstLoaded) {
      this.isCacheLow = true;
      // console.log("缓存不足提示");
      let objData = {
        t: Common.kNoCache,
        len: queLen,
      };
      self.postMessage(objData);
    }
    if (queLen > 0 && !this.isFirstLoaded) {
      this.isFirstLoaded = true;
      this.isCacheLow = false;
      // console.log("缓存恢复提示");
      let objData = {
        t: Common.kCacheAvailable,
        len: queLen,
      };
      self.postMessage(objData);
    }
    if (this.isCacheLow && queLen >= min * 10) {
      this.isCacheLow = false;
      // console.log("缓存恢复提示");
      let objData = {
        t: Common.kCacheAvailable,
        len: queLen,
      };
      self.postMessage(objData);
    }
    if (queLen < min * 25) {
      // 恢复终端码流传输
      this.playBackCtrl(false);
    } else if (queLen > max * 25) {
      // 暂停终端码流传输
      this.playBackCtrl(true);
    }
  }

  /**
   * 处理来自MnPlayer的命令
   **/
  processReq(req) {
    switch (req.t) {
      case Common.kVideoAudioOffset:
        this.offset(req.data);
        break;
      case Common.kOpenDecoderReq:
        this.ws = req.ws;
        this.host = req.host;
        this.port = req.port;
        this.phone = req.phone;
        ((this.userId = req.userId),
          (this.tenantId = req.tenantId),
          (this.token = req.token),
          (this.channel = req.channel));
        this.lang = req.lang;
        this.deviceType = req.deviceType;
        this.renderMode = req.renderMode;
        break;
      case Common.kChangeRenderTypeReq:
        this.renderMode = req.renderMode;
        break;
      case Common.kResumeDecodingReq:
        this.resume();
        break;
      case Common.kPauseDecodingReq:
        this.pause();
        break;
      case Common.kOpenStreamReq:
        this.messageId = req.messageId;
        this.mediaType = req.mediaType;
        this.streamType = req.streamType;
        this.beginTime = req.beginTime;
        this.lang = req.lang;
        this.openStream();
        break;
      case Common.kEnableAudioReq:
        this.enableAudio(req.d);
        break;
      case Common.kSwitchStreamReq:
        this.switchStream(req.m, req.s);
        break;
      case Common.kRecorderSpeakReq:
        this.voiceScheduling = true;
        this.encodeAudio(req.d);
        break;
      case Common.kRecorderTalkReq:
        this.voiceScheduling = false;
        this.encodeAudio(req.d);
        break;
      case Common.kCloseStreamReq:
        this.closeStream();
        break;
      case Common.kFastForward:
        this.fastForward = req.d;
        break;
      case Common.kReplayReq:
        this.play();
        break;
      case Common.kReplaySpeedReq:
        let beginTime = this.beginTime;
        this.playbackMode = req.playbackMode;
        if (req.time) {
          beginTime = req.time;
        } else if (this.preTimeStamp) {
          let t = new Date(this.preTimeStamp);
          beginTime = `${t.getUTCFullYear()}-${(t.getUTCMonth() + 1)
            .toString()
            .padStart(2, "0")}-${t.getUTCDate().toString().padStart(2, "0")} ${t
            .getUTCHours()
            .toString()
            .padStart(2, "0")}:${t
            .getUTCMinutes()
            .toString()
            .padStart(
              2,
              "0",
            )}:${t.getUTCSeconds().toString().padStart(2, "0")}`;
        }

        this.websocket.send(
          JSON.stringify({
            playbackSpeed: req.d,
            messageId: 0x9202,
            channel: this.channel,
            phone: this.phone,
            deviceType: this.deviceType,
            streamType: this.streamType,
            mediaType: this.mediaType,
            host: this.host,
            hostUuid: this.host_uuid,
            port: this.port,
            ws: this.ws,
            beginTime,
            acceptLanguage: this.lang,
            playbackMode: this.playbackMode,
          }),
        );
        this.speed = req.v;
        this.speedValue = req.d;
        break;
      default:
        this.logger.logError("Unsupport messsage " + req.t);
    }
  }

  /**
   * 录音编码（对讲）
   **/
  //判断设备 6 等于QM003  26 = 磁北
  encodeAudio(data) {
    if (this.websocket != null) {
      Module.HEAP8.set(data, this.speakBuffer);
      Module._encodeAudio(
        this.speakBuffer,
        data.length,
        this.deviceType == "6" ? 6 : 26,
      );
    }
  }

  /**
   * 字符串转int8Array
   **/
  toInt8Array(str) {
    let i8a = [];
    for (let i = 0; i < str.length; i++) {
      i8a.push(str.charCodeAt(i));
    }
    return new Int8Array(i8a);
  }

  /**
   * 缓存来自MnPlayer的命令
   **/
  cacheReq(req) {
    if (req) {
      this.cacheReqQue.push(req);
    }
  }

  /**
   * WASM初始化
   **/
  onWasmLoaded() {
    this.wasmLoaded = true;
    this.readyCallback = Module.addFunction(function (width, height) {
      let objData = {
        t: Common.kVideoReady,
        w: width,
        h: height,
      };
      self.postMessage(objData);
    }, "viid");
    let that = this;
    this.videoCallback = Module.addFunction(function (buff, size) {
      let outArray = Module.HEAPU8.subarray(buff, buff + size);
      let data = new Uint8Array(outArray);
      let objData = {
        t: Common.kVideoFrame,
        d: data,
        ti: that.preTimeStamp,
      };
      self.postMessage(objData, [objData.d.buffer]);
    }, "viid");
    this.audioCallback = Module.addFunction(function (buff, size) {
      let outArray = Module.HEAPU8.subarray(buff, buff + size);
      let data = new Uint8Array(outArray);
      let objData = {
        t: Common.kAudioFrame,
        d: data,
        ti: that.voiceTimeStamp,
      };
      self.postMessage(objData, [objData.d.buffer]);
    }, "viid");

    this.speakCallback = Module.addFunction(function (buff, size) {
      let outArray = Module.HEAPU8.subarray(buff, buff + size);
      let data = new Int8Array(outArray);
      if (
        self.decoder.websocket !== null &&
        self.decoder.websocket.readyState === self.decoder.websocket.OPEN
      ) {
        self.decoder.websocket.send(data);
      }
    }, "viid");

    // 执行缓存中的命令
    while (this.cacheReqQue.length > 0) {
      let req = this.cacheReqQue.shift();
      this.processReq(req);
    }
  }
}

self.decoder = new MnWorker();

/**
 * 接收主线程消息
 **/
self.onmessage = function (evt) {
  // console.log("接收主线程消息", evt, self.decoder);
  if (!self.decoder) {
    console.log("[ER] MnWorker not initialized!");
    return;
  }

  let req = evt.data;
  if (!self.decoder.wasmLoaded) {
    // 若尚未初始化，则缓存该命令
    // console.log("缓存命令", req);
    self.decoder.cacheReq(req);
    return;
  }
  // console.log("接收主线程消息", req);
  self.decoder.processReq(req);
};

/**
 * 初始化
 **/
function onWasmLoaded() {
  if (self.decoder) {
    // console.log("WASM加载完成");
    self.decoder.onWasmLoaded();
  } else {
    console.log("[ER] No decoder!");
  }
}
